import { secondaryFontFamily, styled } from '@openeducation/oe-rn-themes';
import type { DefaultTFuncReturn } from 'i18next';
import React, { memo } from 'react';
import {
  StyleProp,
  TextStyle,
  TouchableOpacity,
  ViewStyle,
} from 'react-native';

import { TestId } from '../../constants/test-id';
import { mv } from '../../style-utils';
import { OEText, OETextProps } from '../oe-text/oe-text';

export interface LinkTextProps extends OETextProps {
  onPress: () => void;
  label?: DefaultTFuncReturn;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  fontSize?: number;
  color?: string;
  testID?: string;
}

export const LinkText = ({
  label,
  onPress,
  style,
  textStyle,
  fontSize,
  testID = TestId.LINK_TEXT,
  ...props
}: LinkTextProps) => {
  return (
    <TouchableOpacity onPress={onPress} style={[mv(10), style]}>
      <StyledText
        fontSize={fontSize || 12}
        fontFamily={secondaryFontFamily}
        style={textStyle}
        testID={testID}
        {...props}
      >
        {label}
      </StyledText>
    </TouchableOpacity>
  );
};

const StyledText = styled(OEText).attrs(({ theme, color }) => ({
  width: 'fit-content',
  color: color || theme.color.dark3,
}))``;

export default memo(LinkText);
